import classNames from 'classnames';
import { DatePicker as MuiDatePicker, DatePickerProps } from '@material-ui/pickers';
import { IconButton } from '@material-ui/core';
import InputAdornment from '@material-ui/core/InputAdornment';
import CalendarToday from '@material-ui/icons/CalendarToday';

import { DEFAULT_DATE_FORMAT } from 'enums/date';
import useStyles from './styles';

function DatePicker({
  className,
  disabled,
  name,
  format = DEFAULT_DATE_FORMAT,
  ...rest
}: DatePickerProps) {
  const classes = useStyles();

  return (
    <MuiDatePicker
      clearable
      format={format}
      inputVariant="outlined"
      className={classNames(classes.dateField, className)}
      size="small"
      name={name}
      disabled={disabled}
      InputLabelProps={{ shrink: true }}
      InputProps={{
        notched: false,
        endAdornment: (
          <InputAdornment position="end">
            <IconButton size="small" disabled={disabled}>
              <CalendarToday color="inherit" />
            </IconButton>
          </InputAdornment>
        ),
      }}
      data-testid={`date-field-${name}`}
      {...rest}
    />
  );
}

export default DatePicker;
